import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  Table,
  Pagination,
  FormControl,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import Card from "components/Card/Card.jsx";
import SweetAlert from "react-bootstrap-sweetalert";
import Button from "components/CustomButton/CustomButton.jsx";
import ReactTable from "react-table";
import LoadingSpinner from "views/Components/loadingSpinner";
import NotificationSystem from "react-notification-system";
import { style } from "../../../../variables/Variables";
import {
  GetAllSchedule,
  DeleteDocSchedules,
  GetDocAllUser,
} from "Listfunction";
import moment from "moment";
import { withRouter } from "react-router";

class GlobalSchedule extends Component {
  constructor(props) {
    super(props);
    this.state = {
      docSchdule: [],
      useraccess: "",
      alert: null,
      loading: false,
      currentPage: 1,
      totalPage: 0,
    };
    this.componentDidMount = this.componentDidMount.bind(this);
    //this.getdata = this.getdata.bind(this);
    this.selecteddocSchdule = this.selecteddocSchdule.bind(this);
    this.deletedocSchdule = this.deletedocSchdule.bind(this);
    this.warningWithConfirmAndCancelMessage =
      this.warningWithConfirmAndCancelMessage.bind(this);
  }

  selecteddocSchdule(cus) {
    localStorage.setItem("ds_id", JSON.stringify(cus));
    this.props.history.push("/admin/editschedule");
  }

  handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Global Schedule</b> - Deleted Successfully .
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  handleClick(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Something went wrong</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  warningWithConfirmAndCancelMessage(id) {
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure?"
          onConfirm={() => this.deletedocSchdule(id)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes, delete it!"
          cancelBtnText="Cancel"
          showCancel
        >
          You will not be able to recover this doctor schedule.
        </SweetAlert>
      ),
    });
  }

  hideAlert() {
    this.setState({
      alert: null,
    });
  }

  componentDidMount() {
    this.searchData();

    this.setState({ _notificationSystem: this.refs.notificationSystem });
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700
    );

    /*this.getdata(
        process.env.REACT_APP_NOT_SECRET_CODE + "/medicationCategories"
    );*/
  }

  searchData = () => {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({
      useraccess: token.role,
      loading: true,
    });

    GetAllSchedule(obj, this.state.currentPage)
      .then((res) => {
        var data = res.data.data;
        this.setState({
          docSchdule: data,
          currentPage: res.data.current_page,
          totalPage: res.data.last_page,
          loading: false,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  handleNetworkError(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Network Error</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  /*getdata(url) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({ noRecordFound: false });
 
    this.setState({ loading: true }, () => {
      fetch(url, {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      })
        .then((response) => response.json())
        .then((response1) => {
          var cat_data = response1.data;
          var data = response1.data;
 
          if (data.data.length == 0) {
            this.setState({ noRecordFound: true });
          }
          var $no_pages = [];
          let serach_url = "";
          var category = this.state.search_category;
          var wt_commi = this.state.search_wt_commision;
          let serach_string = "";
          if (category == "") {
            serach_string = serach_string + "";
          } else {
            serach_string = serach_string + "category_name=" + category;
          }
          if (wt_commi == "") {
            serach_string = serach_string + "";
          } else {
            if (serach_string == "") {
              serach_string = serach_string + "wt_commision=" + wt_commi;
            } else {
              serach_string = serach_string + "&wt_commision=" + wt_commi;
            }
          }
          if (serach_string == "") {
            serach_url =
              process.env.REACT_APP_NOT_SECRET_CODE + "/medicationCategories";
          } else {
            serach_url =
              process.env.REACT_APP_NOT_SECRET_CODE +
              "/medicationCategories?" +
              serach_string;
          }
 
          for (var i = 1; i <= data.last_page; i++) {
            if (serach_string == "") {
              $no_pages.push(serach_url + "?page=" + i);
            } else {
              $no_pages.push(serach_url + "&page=" + i);
            }
          }
 
          if (data.current_page == data.last_page) {
            this.setState({ prevdisabled: null });
            this.setState({ nextdisabled: "1" });
          } else if (data.current_page == 1) {
            this.setState({ nextdisabled: null });
            this.setState({ prevdisabled: "1" });
          } else {
            this.setState({ nextdisabled: null });
            this.setState({ prevdisabled: null });
          }
          if (data.last_page == 1) {
            this.setState({ nextdisabled: 1 });
            this.setState({ prevdisabled: 1 });
          }
          if (data.data.length == 0) {
            $no_pages = [];
            this.setState({ nextdisabled: 1 });
            this.setState({ prevdisabled: 1 });
          }
          this.setState({ currentPage: data.current_page });
          if (data.next_page_url != null) {
            if (serach_string == "") {
              this.setState({
                nextpage:
                  serach_url +
                  "?page=" +
                  data.next_page_url.substring(
                    data.next_page_url.indexOf("=") + 1
                  ),
              });
            } else {
              this.setState({
                nextpage:
                  serach_url +
                  "&page=" +
                  data.next_page_url.substring(
                    data.next_page_url.indexOf("=") + 1
                  ),
              });
            }
          } else {
            this.setState({ nextpage: "#" });
          }
          if (data.prev_page_url != null) {
            if (serach_string == "") {
              this.setState({
                prevpage:
                  serach_url +
                  "?page=" +
                  data.prev_page_url.substring(
                    data.prev_page_url.indexOf("=") + 1
                  ),
              });
            } else {
              this.setState({
                prevpage:
                  serach_url +
                  "&page=" +
                  data.prev_page_url.substring(
                    data.prev_page_url.indexOf("=") + 1
                  ),
              });
            }
          } else {
            this.setState({ prevpage: "#" });
          }
          this.setState({ paginationData: $no_pages });
          const tabledata = cat_data.data.map((cus) => {
            const edit = <Tooltip id="edit">Edit </Tooltip>;
            const remove = <Tooltip id="remove">Remove</Tooltip>;
            return (
              <tr>
                <td>{cus.category_name}</td>
                <td>{cus.wt_commision}</td>
                <td>{cus.is_featured == "0" ? "No" : "Yes"}</td>
                <td className="td-actions text-right">
                  <OverlayTrigger placement="top" overlay={edit}>
                    <Button
                      simple
                      bsStyle="success"
                      onClick={this.selectedcategory.bind(this, cus.id)}
                      bsSize="xs"
                    >
                      <Link to="/admin/edit_medication_category">
                        <i className="fa fa-edit" />
                      </Link>
                    </Button>
                  </OverlayTrigger>
                  {this.state.useraccess == 1 && (
                    <OverlayTrigger placement="top" overlay={remove}>
                      <Button
                        simple
                        bsStyle="danger"
                        onClick={this.warningWithConfirmAndCancelMessage.bind(
                          this,
                          cus.id
                        )}
                        bsSize="xs"
                      >
                        <i className="fa fa-times" />
                      </Button>
                    </OverlayTrigger>
                  )}
                </td>
              </tr>
            );
          });
          this.setState({
            loading: false,
            tabledata: tabledata,
          });
        })
        .catch((error) => {
          console.log(error, "== error");
          this.handleNetworkError("bl");
        });
    });
  }*/

  deletedocSchdule(id) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    DeleteDocSchedules(id, obj)
      .then((res) => {
        console.log(res);
        if (res.data.success === false) {
          this.handleClick("bl");
        } else if (res.data.success === true) {
          this.handleSuccess("bl");
          this.searchData();
          this.hideAlert();
        }
      })
      .catch((error) => {
        console.log(error, "== error");
        this.handleNetworkError("bl");
      });
  }

  addSchedule() {
    this.props.history.push("/admin/addschedule");
  }

  paginationData() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    let active = this.state.currentPage;
    this.items = [];
    for (let number = 1; number <= this.state.totalPage; number++) {
      this.items.push(
        <Pagination.Item
          onClick={async () => {
            await this.setState({ currentPage: number });
            this.searchData(obj, number);
          }}
          active={number === active}
        >
          {number}
        </Pagination.Item>
      );
    }
    return this.items;
  }

  render() {
    const edit = <Tooltip id="edit">Edit </Tooltip>;
    const remove = <Tooltip id="remove">Remove</Tooltip>;

    return (
      <div className="main-content">
        <Grid fluid>
          {this.state.alert}
          <NotificationSystem ref="notificationSystem" style={style} />

          <Row>
            <Col md={12}>
              <Card
                tableFullWidth
                content={
                  <Row>
                    <Col md={12}>
                      <Table responsive>
                        <thead>
                          <tr>
                            <th>Doctor</th>
                            <th>Is Active</th>
                            {this.state.useraccess == 1 && (
                              <th className="text-right">Actions</th>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.loading ? (
                            <tr>
                              <td colspan="10">
                                <LoadingSpinner />
                              </td>
                            </tr>
                          ) : this.state.noRecordFound ? (
                            <tr>
                              <td colspan="10">
                                <center>No record found</center>
                              </td>
                            </tr>
                          ) : (
                            <React.Fragment>
                              {this.state.docSchdule.map((cus) => (
                                <tr key={cus.id}>
                                  <td>{cus.name}</td>
                                  <td>{cus.is_active == 1 ? "Yes" : "No"}</td>
                                  {(this.state.useraccess === 1 ||
                                    this.state.useraccess === 9) && (
                                    <td className="td-actions text-right mr-4">
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={edit}
                                      >
                                        <Button
                                          simple
                                          bsStyle="success"
                                          onClick={this.selecteddocSchdule.bind(
                                            this,
                                            cus.id
                                          )}
                                          bsSize="xs"
                                        >
                                          <i className="fa fa-edit" />
                                        </Button>
                                      </OverlayTrigger>
                                    </td>
                                  )}
                                </tr>
                              ))}
                            </React.Fragment>
                          )}
                        </tbody>
                      </Table>

                      {/*this.state.loading ? (
                                                ""
                                            ) : this.state.noRecordFound ? (
                                                ""
                                            ) : (
                                                <div style={{ textAlign: "center" }}>
                                                    <Pagination>
                                                        <Pagination.First
                                                            dataUrl={this.state.prevpage}
                                                            onClick={this.getdata.bind(
                                                                this,
                                                                this.state.prevpage
                                                            )}
                                                            disabled={this.state.prevdisabled}
                                                        />
                                                        {this.state.paginationData.map((url) => (
                                                            <Pagination.Item
                                                                dataUrl={url}
                                                                active={
                                                                    this.state.currentPage == c ? "1" : null
                                                                }
                                                                onClick={this.getdata.bind(this, url)}
                                                            >
                                                                {c++}
                                                            </Pagination.Item>
                                                        ))}
                                                        <Pagination.Last
                                                            dataUrl={this.state.nextpage}
                                                            onClick={this.getdata.bind(
                                                                this,
                                                                this.state.nextpage
                                                            )}
                                                            disabled={this.state.nextdisabled}
                                                        />
                                                    </Pagination>
                                                </div>
                                            )*/}
                    </Col>
                  </Row>
                }
              />
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Pagination bsSize="medium">{this.paginationData()}</Pagination>
              </div>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default withRouter(GlobalSchedule);
